export const CURRENCY = 'USD';
export const LOCALE = 'en-US';
export const PLACEHOLDER = '--';
export const VW_DATE_FORMAT = 'MM/dd/yyyy';
